import React from 'react';
import PropTypes from 'prop-types';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import PreviousButton from 'Components/ComponentLibrary/Atoms/Inputs/PreviousButton';
import { StepNavigatorWrapper } from 'Components/ComponentLibrary/Molecules/StepNavigator/StepNavigatorWrapper';

const StepNavigator = ({
  className,
  onNext,
  onPrevious,
  isLoading,
  disabled,
  children,
}) => {
  return (
    <StepNavigatorWrapper className={className}>
      {onPrevious && (
      <PreviousButton
        test="prev-step"
        disabled={disabled}
        onClick={onPrevious}
      />
      )}
      <RoundedButton
        test="next-step"
        onClick={onNext}
        variant={'contained'}
        isLoading={isLoading}
        color={'primary'}
        fullWidth
        size={DS_SIZE_MAP.sm}
        disabled={disabled || !onNext || isLoading}
      >
        {children}
      </RoundedButton>
    </StepNavigatorWrapper>
  );
};

StepNavigator.defaultProps = {
  className: '',
  onPrevious: null,
  isLoading: false,
  disabled: false,
  children: 'Continue',
  onNext: null,
};

StepNavigator.propTypes = {
  className: PropTypes.string,
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default StepNavigator;
